import React from 'react';
import { MapPinIcon, EditIcon, BuildingIcon, GlobeIcon } from 'lucide-react';
interface GeneralInfoProps {
  data: {
    code: string;
    organizationId: string;
    name: string;
    region: string;
    address: string;
    zipCode: string;
    coordinates: string;
  };
}
export function GeneralInfo({
  data
}: GeneralInfoProps) {
  return <div className="space-y-6" data-id="element-189">
      <div className="flex items-center justify-between" data-id="element-190">
        <div data-id="element-191">
          <h2 className="text-xl font-bold text-gray-900 mb-1" data-id="element-192">
            Warehouse Details
          </h2>
          <p className="text-gray-600 text-sm" data-id="element-193">
            General information and location
          </p>
        </div>
        <button className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all shadow-lg shadow-blue-500/30" data-id="element-194">
          <EditIcon className="w-4 h-4" data-id="element-195" />
          Edit Details
        </button>
      </div>
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-196">
        <div className="p-6" data-id="element-197">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-198">
            <div className="space-y-5" data-id="element-199">
              <div data-id="element-200">
                <label className="flex items-center gap-2 text-gray-600 text-sm font-medium mb-2" data-id="element-201">
                  <BuildingIcon className="w-4 h-4" data-id="element-202" />
                  Oracle Code
                </label>
                <p className="text-gray-900 text-lg font-semibold" data-id="element-203">
                  {data.code}
                </p>
              </div>
              <div data-id="element-204">
                <label className="flex items-center gap-2 text-gray-600 text-sm font-medium mb-2" data-id="element-205">
                  <BuildingIcon className="w-4 h-4" data-id="element-206" />
                  Organization ID
                </label>
                <p className="text-gray-900 text-lg font-semibold" data-id="element-207">
                  {data.organizationId}
                </p>
              </div>
              <div data-id="element-208">
                <label className="flex items-center gap-2 text-gray-600 text-sm font-medium mb-2" data-id="element-209">
                  <BuildingIcon className="w-4 h-4" data-id="element-210" />
                  Warehouse Name
                </label>
                <p className="text-gray-900 text-lg font-semibold" data-id="element-211">
                  {data.name}
                </p>
              </div>
            </div>
            <div className="space-y-5" data-id="element-212">
              <div data-id="element-213">
                <label className="flex items-center gap-2 text-gray-600 text-sm font-medium mb-2" data-id="element-214">
                  <GlobeIcon className="w-4 h-4" data-id="element-215" />
                  Region
                </label>
                <p className="text-gray-900 text-lg font-semibold" data-id="element-216">
                  {data.region}
                </p>
              </div>
              <div data-id="element-217">
                <label className="flex items-center gap-2 text-gray-600 text-sm font-medium mb-2" data-id="element-218">
                  <MapPinIcon className="w-4 h-4" data-id="element-219" />
                  Zip Code
                </label>
                <p className="text-gray-900 text-lg font-semibold" data-id="element-220">
                  {data.zipCode}
                </p>
              </div>
              <div data-id="element-221">
                <label className="flex items-center gap-2 text-gray-600 text-sm font-medium mb-2" data-id="element-222">
                  <MapPinIcon className="w-4 h-4" data-id="element-223" />
                  Coordinates
                </label>
                <p className="text-gray-900 text-lg font-semibold" data-id="element-224">
                  {data.coordinates}
                </p>
              </div>
            </div>
            <div className="md:col-span-2" data-id="element-225">
              <label className="flex items-center gap-2 text-gray-600 text-sm font-medium mb-2" data-id="element-226">
                <MapPinIcon className="w-4 h-4" data-id="element-227" />
                Full Address
              </label>
              <p className="text-gray-900 text-lg font-semibold" data-id="element-228">
                {data.address}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}